// // ============================================================
// // src/components/admin/AdminDashboard.js
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useAuth } from "../../context/AuthContext";
// import ServicesTab from "./ServicesTab";
// import PricingTab from "./PricingTab";
// import PatientsTab from "./PatientsTab";
// import AppointmentsTab from "./AppointmentsTab";
// import BillingTab from "./BillingTab";
// import DoctorAvailabilityTab from "./DoctorAvailabilityTab";
// import DoctorAccountTab from "./DoctorAccountTab";
// import DoctorManageTab from "./DoctorManageTab";
// import HospitalSettingsTab from "./HospitalSettingsTab"; // ✅ NEW
// import AdminNotify from "./AdminNotify";
// import api from "../../utils/api";

// export default function AdminDashboard({ showToast }) {
//   const { doctor, logout } = useAuth();
//   const [activeTab, setActiveTab] = useState("services");
//   const [notify, setNotify] = useState({
//     show: false,
//     title: "",
//     msg: "",
//     error: false,
//   });
//   const [pendingCount, setPendingCount] = useState(0);
//   const [unpaidCount, setUnpaidCount] = useState(0);

//   const showNotify = (title, msg, isError = false) => {
//     setNotify({ show: true, title, msg, error: isError });
//     setTimeout(() => setNotify((n) => ({ ...n, show: false })), 3500);
//   };

//   // Badge: pending appointments
//   useEffect(() => {
//     async function fetchBadge() {
//       try {
//         const data = await api.get("/appointments");
//         if (Array.isArray(data)) {
//           const today = new Date();
//           const yy = today.getFullYear();
//           const mm = String(today.getMonth() + 1).padStart(2, "0");
//           const dd = String(today.getDate()).padStart(2, "0");
//           const ts = `${yy}-${mm}-${dd}`;
//           setPendingCount(
//             data.filter((a) => a.status === "pending" && a.date >= ts).length,
//           );
//         }
//       } catch (_) {}
//     }
//     fetchBadge();
//     const t = setInterval(fetchBadge, 60000);
//     return () => clearInterval(t);
//   }, []);

//   // Badge: unpaid invoices
//   useEffect(() => {
//     async function fetchUnpaid() {
//       try {
//         const data = await api.get("/billing");
//         if (Array.isArray(data)) {
//           setUnpaidCount(data.filter((i) => i.paymentStatus !== "paid").length);
//         }
//       } catch (_) {}
//     }
//     fetchUnpaid();
//     const t = setInterval(fetchUnpaid, 60000);
//     return () => clearInterval(t);
//   }, []);

//   const tabs = [
//     { id: "services", label: "Manage Services" },
//     { id: "pricing", label: "Manage Pricing" },
//     { id: "patients", label: "Patient Profiles" },
//     { id: "appointments", label: "Appointments", badge: pendingCount },
//     { id: "billing", label: "Billings", badge: unpaidCount },
//     { id: "availability", label: "Doctor Available" },
//     { id: "doctoraccount", label: "Doctor Accounts" },
//     { id: "doctormanage", label: "Add Doctor" },
//     { id: "hospitalsettings", label: "🏥 Hospital Settings" }, // ✅ NEW
//   ];

//   return (
//     <>
//       <div className="admin-topbar">
//         <div>
//           <h3>Doctor Admin Panel</h3>
//           <p>
//             Welcome, {doctor?.name} — changes reflect live on the website
//             instantly.
//           </p>
//         </div>
//         <button className="admin-logout" onClick={logout}>
//           Logout
//         </button>
//       </div>
//       <div className="admin-tabs">
//         {tabs.map((t) => (
//           <button
//             key={t.id}
//             className={`admin-tab${activeTab === t.id ? " active" : ""}`}
//             onClick={() => setActiveTab(t.id)}
//             style={{ position: "relative" }}
//           >
//             {t.label}
//             {t.badge > 0 && (
//               <span
//                 style={{
//                   position: "absolute",
//                   top: "-6px",
//                   right: "-6px",
//                   background: "#ef4444",
//                   color: "#fff",
//                   borderRadius: "50%",
//                   width: "18px",
//                   height: "18px",
//                   fontSize: "10px",
//                   fontWeight: 700,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 {t.badge > 99 ? "99+" : t.badge}
//               </span>
//             )}
//           </button>
//         ))}
//       </div>
//       {activeTab === "services" && <ServicesTab showNotify={showNotify} />}
//       {activeTab === "pricing" && <PricingTab showNotify={showNotify} />}
//       {activeTab === "patients" && (
//         <PatientsTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "appointments" && (
//         <AppointmentsTab showNotify={showNotify} />
//       )}
//       {activeTab === "billing" && (
//         <BillingTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "availability" && (
//         <DoctorAvailabilityTab showNotify={showNotify} />
//       )}
//       {activeTab === "doctoraccount" && (
//         <DoctorAccountTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "doctormanage" && (
//         <DoctorManageTab showNotify={showNotify} />
//       )}
//       {activeTab === "hospitalsettings" && (
//         <HospitalSettingsTab showNotify={showNotify} />
//       )}{" "}
//       {/* ✅ NEW */}
//       <AdminNotify
//         show={notify.show}
//         title={notify.title}
//         msg={notify.msg}
//         error={notify.error}
//         onClose={() => setNotify((n) => ({ ...n, show: false }))}
//       />
//     </>
//   );
// }

///////////// below  is correct////////////////////

// // ============================================================
// // src/components/admin/AdminDashboard.js
// // ✅ Subscription tab added
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useAuth } from "../../context/AuthContext";
// import ServicesTab from "./ServicesTab";
// import PricingTab from "./PricingTab";
// import PatientsTab from "./PatientsTab";
// import AppointmentsTab from "./AppointmentsTab";
// import BillingTab from "./BillingTab";
// import DoctorAvailabilityTab from "./DoctorAvailabilityTab";
// import DoctorAccountTab from "./DoctorAccountTab";
// import DoctorManageTab from "./DoctorManageTab";
// import HospitalSettingsTab from "./HospitalSettingsTab";
// import SubscriptionPayment from "./SubscriptionPayment"; // ✅ NEW
// import AdminNotify from "./AdminNotify";
// import api from "../../utils/api";

// export default function AdminDashboard({ showToast }) {
//   const { doctor, logout } = useAuth();
//   const [activeTab, setActiveTab] = useState("services");
//   const [notify, setNotify] = useState({
//     show: false,
//     title: "",
//     msg: "",
//     error: false,
//   });
//   const [pendingCount, setPendingCount] = useState(0);
//   const [unpaidCount, setUnpaidCount] = useState(0);

//   const showNotify = (title, msg, isError = false) => {
//     setNotify({ show: true, title, msg, error: isError });
//     setTimeout(() => setNotify((n) => ({ ...n, show: false })), 3500);
//   };

//   // Badge: pending appointments
//   useEffect(() => {
//     async function fetchBadge() {
//       try {
//         const data = await api.get("/appointments");
//         if (Array.isArray(data)) {
//           const today = new Date();
//           const ts = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
//           setPendingCount(
//             data.filter((a) => a.status === "pending" && a.date >= ts).length,
//           );
//         }
//       } catch (_) {}
//     }
//     fetchBadge();
//     const t = setInterval(fetchBadge, 60000);
//     return () => clearInterval(t);
//   }, []);

//   // Badge: unpaid invoices
//   useEffect(() => {
//     async function fetchUnpaid() {
//       try {
//         const data = await api.get("/billing");
//         if (Array.isArray(data))
//           setUnpaidCount(data.filter((i) => i.paymentStatus !== "paid").length);
//       } catch (_) {}
//     }
//     fetchUnpaid();
//     const t = setInterval(fetchUnpaid, 60000);
//     return () => clearInterval(t);
//   }, []);

//   const tabs = [
//     { id: "services", label: "Manage Services" },
//     { id: "pricing", label: "Manage Pricing" },
//     { id: "patients", label: "Patient Profiles" },
//     { id: "appointments", label: "Appointments", badge: pendingCount },
//     { id: "billing", label: "Billings", badge: unpaidCount },
//     { id: "availability", label: "Doctor Available" },
//     { id: "doctoraccount", label: "Doctor Accounts" },
//     { id: "doctormanage", label: "Add Doctor" },
//     { id: "hospitalsettings", label: "🏥 Hospital Settings" },
//     { id: "subscription", label: "💳 Subscription" }, // ✅ NEW
//   ];

//   return (
//     <>
//       <div className="admin-topbar">
//         <div>
//           <h3>Doctor Admin Panel</h3>
//           <p>
//             Welcome, {doctor?.name} — changes reflect live on the website
//             instantly.
//           </p>
//         </div>
//         <button className="admin-logout" onClick={logout}>
//           Logout
//         </button>
//       </div>
//       <div className="admin-tabs">
//         {tabs.map((t) => (
//           <button
//             key={t.id}
//             className={`admin-tab${activeTab === t.id ? " active" : ""}`}
//             onClick={() => setActiveTab(t.id)}
//             style={{ position: "relative" }}
//           >
//             {t.label}
//             {t.badge > 0 && (
//               <span
//                 style={{
//                   position: "absolute",
//                   top: "-6px",
//                   right: "-6px",
//                   background: "#ef4444",
//                   color: "#fff",
//                   borderRadius: "50%",
//                   width: "18px",
//                   height: "18px",
//                   fontSize: "10px",
//                   fontWeight: 700,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 {t.badge > 99 ? "99+" : t.badge}
//               </span>
//             )}
//           </button>
//         ))}
//       </div>
//       {activeTab === "services" && <ServicesTab showNotify={showNotify} />}
//       {activeTab === "pricing" && <PricingTab showNotify={showNotify} />}
//       {activeTab === "patients" && (
//         <PatientsTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "appointments" && (
//         <AppointmentsTab showNotify={showNotify} />
//       )}
//       {activeTab === "billing" && (
//         <BillingTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "availability" && (
//         <DoctorAvailabilityTab showNotify={showNotify} />
//       )}
//       {activeTab === "doctoraccount" && (
//         <DoctorAccountTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "doctormanage" && (
//         <DoctorManageTab showNotify={showNotify} />
//       )}
//       {activeTab === "hospitalsettings" && (
//         <HospitalSettingsTab showNotify={showNotify} />
//       )}
//       {activeTab === "subscription" && (
//         <SubscriptionPayment showNotify={showNotify} />
//       )}{" "}
//       {/* ✅ NEW */}
//       <AdminNotify
//         show={notify.show}
//         title={notify.title}
//         msg={notify.msg}
//         error={notify.error}
//         onClose={() => setNotify((n) => ({ ...n, show: false }))}
//       />
//     </>
//   );
// }

////////////// test case below //////////
// // ============================================================
// // src/components/admin/AdminDashboard.js
// // ✅ Subscription tab added
// // ✅ No other changes — DoctorAccountTab reads plan from useHospital internally
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useAuth } from "../../context/AuthContext";
// import ServicesTab from "./ServicesTab";
// import PricingTab from "./PricingTab";
// import PatientsTab from "./PatientsTab";
// import AppointmentsTab from "./AppointmentsTab";
// import BillingTab from "./BillingTab";
// import DoctorAvailabilityTab from "./DoctorAvailabilityTab";
// import DoctorAccountTab from "./DoctorAccountTab";
// import DoctorManageTab from "./DoctorManageTab";
// import HospitalSettingsTab from "./HospitalSettingsTab";
// import SubscriptionPayment from "./SubscriptionPayment";
// import AdminNotify from "./AdminNotify";
// import api from "../../utils/api";

// export default function AdminDashboard({ showToast }) {
//   const { doctor, logout } = useAuth();
//   const [activeTab, setActiveTab] = useState("services");
//   const [notify, setNotify] = useState({
//     show: false,
//     title: "",
//     msg: "",
//     error: false,
//   });
//   const [pendingCount, setPendingCount] = useState(0);
//   const [unpaidCount, setUnpaidCount] = useState(0);

//   const showNotify = (title, msg, isError = false) => {
//     setNotify({ show: true, title, msg, error: isError });
//     setTimeout(() => setNotify((n) => ({ ...n, show: false })), 3500);
//   };

//   // Badge: pending appointments
//   useEffect(() => {
//     async function fetchBadge() {
//       try {
//         const data = await api.get("/appointments");
//         if (Array.isArray(data)) {
//           const today = new Date();
//           const ts = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
//           setPendingCount(
//             data.filter((a) => a.status === "pending" && a.date >= ts).length,
//           );
//         }
//       } catch (_) {}
//     }
//     fetchBadge();
//     const t = setInterval(fetchBadge, 60000);
//     return () => clearInterval(t);
//   }, []);

//   // Badge: unpaid invoices
//   useEffect(() => {
//     async function fetchUnpaid() {
//       try {
//         const data = await api.get("/billing");
//         if (Array.isArray(data))
//           setUnpaidCount(data.filter((i) => i.paymentStatus !== "paid").length);
//       } catch (_) {}
//     }
//     fetchUnpaid();
//     const t = setInterval(fetchUnpaid, 60000);
//     return () => clearInterval(t);
//   }, []);

//   const tabs = [
//     { id: "services", label: "Manage Services" },
//     { id: "pricing", label: "Manage Pricing" },
//     { id: "patients", label: "Patient Profiles" },
//     { id: "appointments", label: "Appointments", badge: pendingCount },
//     { id: "billing", label: "Billings", badge: unpaidCount },
//     { id: "availability", label: "Doctor Available" },
//     { id: "doctoraccount", label: "Doctor Accounts" },
//     { id: "doctormanage", label: "Add Doctor" },
//     { id: "hospitalsettings", label: "🏥 Hospital Settings" },
//     { id: "subscription", label: "💳 Subscription" },
//   ];

//   return (
//     <>
//       <div className="admin-topbar">
//         <div>
//           <h3>Doctor Admin Panel</h3>
//           <p>
//             Welcome, {doctor?.name} — changes reflect live on the website
//             instantly.
//           </p>
//         </div>
//         <button className="admin-logout" onClick={logout}>
//           Logout
//         </button>
//       </div>
//       <div className="admin-tabs">
//         {tabs.map((t) => (
//           <button
//             key={t.id}
//             className={`admin-tab${activeTab === t.id ? " active" : ""}`}
//             onClick={() => setActiveTab(t.id)}
//             style={{ position: "relative" }}
//           >
//             {t.label}
//             {t.badge > 0 && (
//               <span
//                 style={{
//                   position: "absolute",
//                   top: "-6px",
//                   right: "-6px",
//                   background: "#ef4444",
//                   color: "#fff",
//                   borderRadius: "50%",
//                   width: "18px",
//                   height: "18px",
//                   fontSize: "10px",
//                   fontWeight: 700,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 {t.badge > 99 ? "99+" : t.badge}
//               </span>
//             )}
//           </button>
//         ))}
//       </div>
//       {activeTab === "services" && <ServicesTab showNotify={showNotify} />}
//       {activeTab === "pricing" && <PricingTab showNotify={showNotify} />}
//       {activeTab === "patients" && (
//         <PatientsTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "appointments" && (
//         <AppointmentsTab showNotify={showNotify} />
//       )}
//       {activeTab === "billing" && (
//         <BillingTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "availability" && (
//         <DoctorAvailabilityTab showNotify={showNotify} />
//       )}
//       {activeTab === "doctoraccount" && (
//         <DoctorAccountTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "doctormanage" && (
//         <DoctorManageTab showNotify={showNotify} />
//       )}
//       {activeTab === "hospitalsettings" && (
//         <HospitalSettingsTab showNotify={showNotify} />
//       )}
//       {activeTab === "subscription" && (
//         <SubscriptionPayment showNotify={showNotify} />
//       )}
//       <AdminNotify
//         show={notify.show}
//         title={notify.title}
//         msg={notify.msg}
//         error={notify.error}
//         onClose={() => setNotify((n) => ({ ...n, show: false }))}
//       />
//     </>
//   );
// }

//////////////////// above is correct code css testing below////////////

// // ============================================================
// // src/components/admin/AdminDashboard.js
// // ✅ Subscription tab added
// // ✅ Fully responsive for mobile, tablet, laptop, desktop
// // ✅ No other content changes — DoctorAccountTab reads plan from useHospital internally
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useAuth } from "../../context/AuthContext";
// import ServicesTab from "./ServicesTab";
// import PricingTab from "./PricingTab";
// import PatientsTab from "./PatientsTab";
// import AppointmentsTab from "./AppointmentsTab";
// import BillingTab from "./BillingTab";
// import DoctorAvailabilityTab from "./DoctorAvailabilityTab";
// import DoctorAccountTab from "./DoctorAccountTab";
// import DoctorManageTab from "./DoctorManageTab";
// import HospitalSettingsTab from "./HospitalSettingsTab";
// import SubscriptionPayment from "./SubscriptionPayment";
// import AdminNotify from "./AdminNotify";
// import api from "../../utils/api";

// const responsiveStyles = `
//   /* ─── Top Bar ─────────────────────────────────────────────── */
//   .admin-topbar {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     flex-wrap: wrap;
//     gap: 10px;
//     padding: 14px 20px;
//     background: #0f172a;
//     color: #fff;
//   }

//   .admin-topbar h3 {
//     margin: 0 0 2px;
//     font-size: 1.1rem;
//     font-weight: 700;
//   }

//   .admin-topbar p {
//     margin: 0;
//     font-size: 0.82rem;
//     color: #94a3b8;
//   }

//   .admin-logout {
//     flex-shrink: 0;
//     padding: 8px 18px;
//     background: transparent;
//     color: #fff;
//     border: 1.5px solid rgba(255,255,255,0.35);
//     border-radius: 8px;
//     font-size: 0.85rem;
//     font-weight: 600;
//     cursor: pointer;
//     transition: background 0.18s, border-color 0.18s;
//     white-space: nowrap;
//   }

//   .admin-logout:hover {
//     background: rgba(255,255,255,0.1);
//     border-color: #fff;
//   }

//   /* ─── Tab Bar ──────────────────────────────────────────────── */
//   .admin-tabs {
//     display: flex;
//     flex-wrap: wrap;           /* KEY: wrap tabs instead of overflow */
//     gap: 4px;
//     padding: 10px 16px;
//     background: #f1f5f9;
//     border-bottom: 1px solid #e2e8f0;
//   }

//   .admin-tab {
//     position: relative;
//     padding: 8px 14px;
//     background: #fff;
//     color: #475569;
//     border: 1.5px solid #e2e8f0;
//     border-radius: 8px;
//     font-size: 0.82rem;
//     font-weight: 500;
//     cursor: pointer;
//     white-space: nowrap;
//     transition: background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;
//     line-height: 1.3;
//   }

//   .admin-tab:hover {
//     background: #f8fafc;
//     border-color: #94a3b8;
//     color: #1e293b;
//   }

//   .admin-tab.active {
//     background: #0f172a;
//     color: #fff;
//     border-color: #0f172a;
//     box-shadow: 0 2px 8px rgba(15,23,42,0.18);
//   }

//   /* ─── Badge ────────────────────────────────────────────────── */
//   .admin-tab-badge {
//     position: absolute;
//     top: -6px;
//     right: -6px;
//     background: #ef4444;
//     color: #fff;
//     border-radius: 50%;
//     min-width: 18px;
//     height: 18px;
//     font-size: 10px;
//     font-weight: 700;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 3px;
//     line-height: 1;
//     pointer-events: none;
//   }

//   /* ─── Mobile (≤ 480px) ─────────────────────────────────────── */
//   @media (max-width: 480px) {
//     .admin-topbar {
//       padding: 12px 14px;
//     }

//     .admin-topbar h3 {
//       font-size: 0.97rem;
//     }

//     .admin-topbar p {
//       font-size: 0.75rem;
//     }

//     .admin-logout {
//       padding: 6px 13px;
//       font-size: 0.78rem;
//     }

//     .admin-tabs {
//       gap: 6px;
//       padding: 10px 12px;
//     }

//     .admin-tab {
//       font-size: 0.78rem;
//       padding: 7px 11px;
//       border-radius: 7px;
//       /* On very small screens let tabs expand to fill row if needed */
//       flex: 1 1 auto;
//       text-align: center;
//     }
//   }

//   /* ─── Small tablet (481px – 767px) ────────────────────────── */
//   @media (min-width: 481px) and (max-width: 767px) {
//     .admin-tabs {
//       gap: 6px;
//       padding: 10px 14px;
//     }

//     .admin-tab {
//       font-size: 0.8rem;
//       padding: 7px 12px;
//     }
//   }

//   /* ─── Tablet (768px – 1023px) ──────────────────────────────── */
//   @media (min-width: 768px) and (max-width: 1023px) {
//     .admin-tabs {
//       gap: 6px;
//       padding: 10px 16px;
//     }

//     .admin-tab {
//       font-size: 0.82rem;
//       padding: 8px 13px;
//     }
//   }

//   /* ─── Laptop / Desktop (≥ 1024px) ─────────────────────────── */
//   @media (min-width: 1024px) {
//     .admin-tabs {
//       gap: 6px;
//       padding: 10px 20px;
//     }

//     .admin-tab {
//       font-size: 0.84rem;
//       padding: 8px 16px;
//     }
//   }

//   /* ─── Large Desktop (≥ 1440px) ────────────────────────────── */
//   @media (min-width: 1440px) {
//     .admin-tabs {
//       padding: 12px 28px;
//       gap: 8px;
//     }

//     .admin-tab {
//       font-size: 0.88rem;
//       padding: 9px 18px;
//     }
//   }
// `;

// export default function AdminDashboard({ showToast }) {
//   const { doctor, logout } = useAuth();
//   const [activeTab, setActiveTab] = useState("services");
//   const [notify, setNotify] = useState({
//     show: false,
//     title: "",
//     msg: "",
//     error: false,
//   });
//   const [pendingCount, setPendingCount] = useState(0);
//   const [unpaidCount, setUnpaidCount] = useState(0);

//   const showNotify = (title, msg, isError = false) => {
//     setNotify({ show: true, title, msg, error: isError });
//     setTimeout(() => setNotify((n) => ({ ...n, show: false })), 3500);
//   };

//   // Badge: pending appointments
//   useEffect(() => {
//     async function fetchBadge() {
//       try {
//         const data = await api.get("/appointments");
//         if (Array.isArray(data)) {
//           const today = new Date();
//           const ts = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
//           setPendingCount(
//             data.filter((a) => a.status === "pending" && a.date >= ts).length,
//           );
//         }
//       } catch (_) {}
//     }
//     fetchBadge();
//     const t = setInterval(fetchBadge, 60000);
//     return () => clearInterval(t);
//   }, []);

//   // Badge: unpaid invoices
//   useEffect(() => {
//     async function fetchUnpaid() {
//       try {
//         const data = await api.get("/billing");
//         if (Array.isArray(data))
//           setUnpaidCount(data.filter((i) => i.paymentStatus !== "paid").length);
//       } catch (_) {}
//     }
//     fetchUnpaid();
//     const t = setInterval(fetchUnpaid, 60000);
//     return () => clearInterval(t);
//   }, []);

//   const tabs = [
//     { id: "services", label: "Manage Services" },
//     { id: "pricing", label: "Manage Pricing" },
//     { id: "patients", label: "Patient Profiles" },
//     { id: "appointments", label: "Appointments", badge: pendingCount },
//     { id: "billing", label: "Billings", badge: unpaidCount },
//     { id: "availability", label: "Doctor Available" },
//     { id: "doctoraccount", label: "Doctor Accounts" },
//     { id: "doctormanage", label: "Add Doctor" },
//     { id: "hospitalsettings", label: "🏥 Hospital Settings" },
//     { id: "subscription", label: "💳 Subscription" },
//   ];

//   return (
//     <>
//       {/* Inject responsive styles once */}
//       <style>{responsiveStyles}</style>

//       <div className="admin-topbar">
//         <div>
//           <h3>Doctor Admin Panel</h3>
//           <p>
//             Welcome, {doctor?.name} — changes reflect live on the website
//             instantly.
//           </p>
//         </div>
//         <button className="admin-logout" onClick={logout}>
//           Logout
//         </button>
//       </div>

//       <div className="admin-tabs">
//         {tabs.map((t) => (
//           <button
//             key={t.id}
//             className={`admin-tab${activeTab === t.id ? " active" : ""}`}
//             onClick={() => setActiveTab(t.id)}
//           >
//             {t.label}
//             {t.badge > 0 && (
//               <span className="admin-tab-badge">
//                 {t.badge > 99 ? "99+" : t.badge}
//               </span>
//             )}
//           </button>
//         ))}
//       </div>

//       {activeTab === "services" && <ServicesTab showNotify={showNotify} />}
//       {activeTab === "pricing" && <PricingTab showNotify={showNotify} />}
//       {activeTab === "patients" && (
//         <PatientsTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "appointments" && (
//         <AppointmentsTab showNotify={showNotify} />
//       )}
//       {activeTab === "billing" && (
//         <BillingTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "availability" && (
//         <DoctorAvailabilityTab showNotify={showNotify} />
//       )}
//       {activeTab === "doctoraccount" && (
//         <DoctorAccountTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "doctormanage" && (
//         <DoctorManageTab showNotify={showNotify} />
//       )}
//       {activeTab === "hospitalsettings" && (
//         <HospitalSettingsTab showNotify={showNotify} />
//       )}
//       {activeTab === "subscription" && (
//         <SubscriptionPayment showNotify={showNotify} />
//       )}

//       <AdminNotify
//         show={notify.show}
//         title={notify.title}
//         msg={notify.msg}
//         error={notify.error}
//         onClose={() => setNotify((n) => ({ ...n, show: false }))}
//       />
//     </>
//   );
// }

//////////// razorpay
// // ============================================================
// // src/components/admin/AdminDashboard.js
// // ✅ Subscription tab added
// // ✅ Fully responsive for mobile, tablet, laptop, desktop
// // ✅ RenewSubscription banner added at top
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useAuth } from "../../context/AuthContext";
// import ServicesTab from "./ServicesTab";
// import PricingTab from "./PricingTab";
// import PatientsTab from "./PatientsTab";
// import AppointmentsTab from "./AppointmentsTab";
// import BillingTab from "./BillingTab";
// import DoctorAvailabilityTab from "./DoctorAvailabilityTab";
// import DoctorAccountTab from "./DoctorAccountTab";
// import DoctorManageTab from "./DoctorManageTab";
// import HospitalSettingsTab from "./HospitalSettingsTab";
// import SubscriptionPayment from "./SubscriptionPayment";
// import RenewSubscription from "./RenewSubscription";
// import AdminNotify from "./AdminNotify";
// import api from "../../utils/api";

// const responsiveStyles = `
//   /* ─── Top Bar ─────────────────────────────────────────────── */
//   .admin-topbar {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     flex-wrap: wrap;
//     gap: 10px;
//     padding: 14px 20px;
//     background: #0f172a;
//     color: #fff;
//   }

//   .admin-topbar h3 {
//     margin: 0 0 2px;
//     font-size: 1.1rem;
//     font-weight: 700;
//   }

//   .admin-topbar p {
//     margin: 0;
//     font-size: 0.82rem;
//     color: #94a3b8;
//   }

//   .admin-logout {
//     flex-shrink: 0;
//     padding: 8px 18px;
//     background: transparent;
//     color: #fff;
//     border: 1.5px solid rgba(255,255,255,0.35);
//     border-radius: 8px;
//     font-size: 0.85rem;
//     font-weight: 600;
//     cursor: pointer;
//     transition: background 0.18s, border-color 0.18s;
//     white-space: nowrap;
//   }

//   .admin-logout:hover {
//     background: rgba(255,255,255,0.1);
//     border-color: #fff;
//   }

//   /* ─── Tab Bar ──────────────────────────────────────────────── */
//   .admin-tabs {
//     display: flex;
//     flex-wrap: wrap;
//     gap: 4px;
//     padding: 10px 16px;
//     background: #f1f5f9;
//     border-bottom: 1px solid #e2e8f0;
//   }

//   .admin-tab {
//     position: relative;
//     padding: 8px 14px;
//     background: #fff;
//     color: #475569;
//     border: 1.5px solid #e2e8f0;
//     border-radius: 8px;
//     font-size: 0.82rem;
//     font-weight: 500;
//     cursor: pointer;
//     white-space: nowrap;
//     transition: background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;
//     line-height: 1.3;
//   }

//   .admin-tab:hover {
//     background: #f8fafc;
//     border-color: #94a3b8;
//     color: #1e293b;
//   }

//   .admin-tab.active {
//     background: #0f172a;
//     color: #fff;
//     border-color: #0f172a;
//     box-shadow: 0 2px 8px rgba(15,23,42,0.18);
//   }

//   /* ─── Badge ────────────────────────────────────────────────── */
//   .admin-tab-badge {
//     position: absolute;
//     top: -6px;
//     right: -6px;
//     background: #ef4444;
//     color: #fff;
//     border-radius: 50%;
//     min-width: 18px;
//     height: 18px;
//     font-size: 10px;
//     font-weight: 700;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 3px;
//     line-height: 1;
//     pointer-events: none;
//   }

//   /* ─── Mobile (≤ 480px) ─────────────────────────────────────── */
//   @media (max-width: 480px) {
//     .admin-topbar { padding: 12px 14px; }
//     .admin-topbar h3 { font-size: 0.97rem; }
//     .admin-topbar p { font-size: 0.75rem; }
//     .admin-logout { padding: 6px 13px; font-size: 0.78rem; }
//     .admin-tabs { gap: 6px; padding: 10px 12px; }
//     .admin-tab {
//       font-size: 0.78rem;
//       padding: 7px 11px;
//       border-radius: 7px;
//       flex: 1 1 auto;
//       text-align: center;
//     }
//   }

//   /* ─── Small tablet (481px – 767px) ────────────────────────── */
//   @media (min-width: 481px) and (max-width: 767px) {
//     .admin-tabs { gap: 6px; padding: 10px 14px; }
//     .admin-tab { font-size: 0.8rem; padding: 7px 12px; }
//   }

//   /* ─── Tablet (768px – 1023px) ──────────────────────────────── */
//   @media (min-width: 768px) and (max-width: 1023px) {
//     .admin-tabs { gap: 6px; padding: 10px 16px; }
//     .admin-tab { font-size: 0.82rem; padding: 8px 13px; }
//   }

//   /* ─── Laptop / Desktop (≥ 1024px) ─────────────────────────── */
//   @media (min-width: 1024px) {
//     .admin-tabs { gap: 6px; padding: 10px 20px; }
//     .admin-tab { font-size: 0.84rem; padding: 8px 16px; }
//   }

//   /* ─── Large Desktop (≥ 1440px) ────────────────────────────── */
//   @media (min-width: 1440px) {
//     .admin-tabs { padding: 12px 28px; gap: 8px; }
//     .admin-tab { font-size: 0.88rem; padding: 9px 18px; }
//   }
// `;

// export default function AdminDashboard({ showToast }) {
//   const { doctor, logout } = useAuth();
//   const [activeTab, setActiveTab] = useState("services");
//   const [notify, setNotify] = useState({
//     show: false,
//     title: "",
//     msg: "",
//     error: false,
//   });
//   const [pendingCount, setPendingCount] = useState(0);
//   const [unpaidCount, setUnpaidCount] = useState(0);

//   const showNotify = (title, msg, isError = false) => {
//     setNotify({ show: true, title, msg, error: isError });
//     setTimeout(() => setNotify((n) => ({ ...n, show: false })), 3500);
//   };

//   // Badge: pending appointments
//   useEffect(() => {
//     async function fetchBadge() {
//       try {
//         const data = await api.get("/appointments");
//         if (Array.isArray(data)) {
//           const today = new Date();
//           const ts = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
//           setPendingCount(
//             data.filter((a) => a.status === "pending" && a.date >= ts).length,
//           );
//         }
//       } catch (_) {}
//     }
//     fetchBadge();
//     const t = setInterval(fetchBadge, 60000);
//     return () => clearInterval(t);
//   }, []);

//   // Badge: unpaid invoices
//   useEffect(() => {
//     async function fetchUnpaid() {
//       try {
//         const data = await api.get("/billing");
//         if (Array.isArray(data))
//           setUnpaidCount(data.filter((i) => i.paymentStatus !== "paid").length);
//       } catch (_) {}
//     }
//     fetchUnpaid();
//     const t = setInterval(fetchUnpaid, 60000);
//     return () => clearInterval(t);
//   }, []);

//   const tabs = [
//     { id: "services", label: "Manage Services" },
//     { id: "pricing", label: "Manage Pricing" },
//     { id: "patients", label: "Patient Profiles" },
//     { id: "appointments", label: "Appointments", badge: pendingCount },
//     { id: "billing", label: "Billings", badge: unpaidCount },
//     { id: "availability", label: "Doctor Available" },
//     { id: "doctoraccount", label: "Doctor Accounts" },
//     { id: "doctormanage", label: "Add Doctor" },
//     { id: "hospitalsettings", label: "🏥 Hospital Settings" },
//     { id: "subscription", label: "💳 Subscription" },
//   ];

//   return (
//     <>
//       {/* Inject responsive styles */}
//       <style>{responsiveStyles}</style>

//       {/* Top Bar */}
//       <div className="admin-topbar">
//         <div>
//           <h3>Doctor Admin Panel</h3>
//           <p>
//             Welcome, {doctor?.name} — changes reflect live on the website
//             instantly.
//           </p>
//         </div>
//         <button className="admin-logout" onClick={logout}>
//           Logout
//         </button>
//       </div>

//       {/* ✅ Renewal banner — shows automatically when expiry is near or expired */}
//       <RenewSubscription showNotify={showNotify} />

//       {/* Tab Bar */}
//       <div className="admin-tabs">
//         {tabs.map((t) => (
//           <button
//             key={t.id}
//             className={`admin-tab${activeTab === t.id ? " active" : ""}`}
//             onClick={() => setActiveTab(t.id)}
//           >
//             {t.label}
//             {t.badge > 0 && (
//               <span className="admin-tab-badge">
//                 {t.badge > 99 ? "99+" : t.badge}
//               </span>
//             )}
//           </button>
//         ))}
//       </div>

//       {/* Tab Content */}
//       {activeTab === "services" && <ServicesTab showNotify={showNotify} />}
//       {activeTab === "pricing" && <PricingTab showNotify={showNotify} />}
//       {activeTab === "patients" && (
//         <PatientsTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "appointments" && (
//         <AppointmentsTab showNotify={showNotify} />
//       )}
//       {activeTab === "billing" && (
//         <BillingTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "availability" && (
//         <DoctorAvailabilityTab showNotify={showNotify} />
//       )}
//       {activeTab === "doctoraccount" && (
//         <DoctorAccountTab showNotify={showNotify} doctor={doctor} />
//       )}
//       {activeTab === "doctormanage" && (
//         <DoctorManageTab showNotify={showNotify} />
//       )}
//       {activeTab === "hospitalsettings" && (
//         <HospitalSettingsTab showNotify={showNotify} />
//       )}
//       {activeTab === "subscription" && (
//         <SubscriptionPayment showNotify={showNotify} />
//       )}

//       <AdminNotify
//         show={notify.show}
//         title={notify.title}
//         msg={notify.msg}
//         error={notify.error}
//         onClose={() => setNotify((n) => ({ ...n, show: false }))}
//       />
//     </>
//   );
// }

/////////////// dashboard check ////////
// ============================================================
// src/components/admin/AdminDashboard.js
// ✅ Subscription tab added
// ✅ Fully responsive for mobile, tablet, laptop, desktop
// ✅ RenewSubscription banner added at top
// ✅ NEW: Hospital Dashboard tab added
// ============================================================
import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import ServicesTab from "./ServicesTab";
import PricingTab from "./PricingTab";
import PatientsTab from "./PatientsTab";
import AppointmentsTab from "./AppointmentsTab";
import BillingTab from "./BillingTab";
import DoctorAvailabilityTab from "./DoctorAvailabilityTab";
import DoctorAccountTab from "./DoctorAccountTab";
import DoctorManageTab from "./DoctorManageTab";
import HospitalSettingsTab from "./HospitalSettingsTab";
import SubscriptionPayment from "./SubscriptionPayment";
import RenewSubscription from "./RenewSubscription";
import AdminNotify from "./AdminNotify";
import BillingDashboard from "./BillingDashboard";
import api from "../../utils/api";

const responsiveStyles = `
  /* ─── Top Bar ─────────────────────────────────────────────── */
  .admin-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    padding: 14px 20px;
    background: #0f172a;
    color: #fff;
  }

  .admin-topbar h3 {
    margin: 0 0 2px;
    font-size: 1.1rem;
    font-weight: 700;
  }

  .admin-topbar p {
    margin: 0;
    font-size: 0.82rem;
    color: #94a3b8;
  }

  .admin-logout {
    flex-shrink: 0;
    padding: 8px 18px;
    background: transparent;
    color: #fff;
    border: 1.5px solid rgba(255,255,255,0.35);
    border-radius: 8px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.18s, border-color 0.18s;
    white-space: nowrap;
  }

  .admin-logout:hover {
    background: rgba(255,255,255,0.1);
    border-color: #fff;
  }

  /* ─── Tab Bar ──────────────────────────────────────────────── */
  .admin-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 10px 16px;
    background: #f1f5f9;
    border-bottom: 1px solid #e2e8f0;
  }

  .admin-tab {
    position: relative;
    padding: 8px 14px;
    background: #fff;
    color: #475569;
    border: 1.5px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.82rem;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;
    line-height: 1.3;
  }

  .admin-tab:hover {
    background: #f8fafc;
    border-color: #94a3b8;
    color: #1e293b;
  }

  .admin-tab.active {
    background: #0f172a;
    color: #fff;
    border-color: #0f172a;
    box-shadow: 0 2px 8px rgba(15,23,42,0.18);
  }

  /* ─── Badge ────────────────────────────────────────────────── */
  .admin-tab-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    background: #ef4444;
    color: #fff;
    border-radius: 50%;
    min-width: 18px;
    height: 18px;
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
    line-height: 1;
    pointer-events: none;
  }

  /* ─── Mobile (≤ 480px) ─────────────────────────────────────── */
  @media (max-width: 480px) {
    .admin-topbar { padding: 12px 14px; }
    .admin-topbar h3 { font-size: 0.97rem; }
    .admin-topbar p { font-size: 0.75rem; }
    .admin-logout { padding: 6px 13px; font-size: 0.78rem; }
    .admin-tabs { gap: 6px; padding: 10px 12px; }
    .admin-tab {
      font-size: 0.78rem;
      padding: 7px 11px;
      border-radius: 7px;
      flex: 1 1 auto;
      text-align: center;
    }
  }

  /* ─── Small tablet (481px – 767px) ────────────────────────── */
  @media (min-width: 481px) and (max-width: 767px) {
    .admin-tabs { gap: 6px; padding: 10px 14px; }
    .admin-tab { font-size: 0.8rem; padding: 7px 12px; }
  }

  /* ─── Tablet (768px – 1023px) ──────────────────────────────── */
  @media (min-width: 768px) and (max-width: 1023px) {
    .admin-tabs { gap: 6px; padding: 10px 16px; }
    .admin-tab { font-size: 0.82rem; padding: 8px 13px; }
  }

  /* ─── Laptop / Desktop (≥ 1024px) ─────────────────────────── */
  @media (min-width: 1024px) {
    .admin-tabs { gap: 6px; padding: 10px 20px; }
    .admin-tab { font-size: 0.84rem; padding: 8px 16px; }
  }

  /* ─── Large Desktop (≥ 1440px) ────────────────────────────── */
  @media (min-width: 1440px) {
    .admin-tabs { padding: 12px 28px; gap: 8px; }
    .admin-tab { font-size: 0.88rem; padding: 9px 18px; }
  }
`;

export default function AdminDashboard({ showToast }) {
  const { doctor, logout } = useAuth();
  const [activeTab, setActiveTab] = useState("services");
  const [notify, setNotify] = useState({
    show: false,
    title: "",
    msg: "",
    error: false,
  });
  const [pendingCount, setPendingCount] = useState(0);
  const [unpaidCount, setUnpaidCount] = useState(0);

  const showNotify = (title, msg, isError = false) => {
    setNotify({ show: true, title, msg, error: isError });
    setTimeout(() => setNotify((n) => ({ ...n, show: false })), 3500);
  };

  // Badge: pending appointments
  useEffect(() => {
    async function fetchBadge() {
      try {
        const data = await api.get("/appointments");
        if (Array.isArray(data)) {
          const today = new Date();
          const ts = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
          setPendingCount(
            data.filter((a) => a.status === "pending" && a.date >= ts).length,
          );
        }
      } catch (_) {}
    }
    fetchBadge();
    const t = setInterval(fetchBadge, 60000);
    return () => clearInterval(t);
  }, []);

  // Badge: unpaid invoices
  useEffect(() => {
    async function fetchUnpaid() {
      try {
        const data = await api.get("/billing");
        if (Array.isArray(data))
          setUnpaidCount(data.filter((i) => i.paymentStatus !== "paid").length);
      } catch (_) {}
    }
    fetchUnpaid();
    const t = setInterval(fetchUnpaid, 60000);
    return () => clearInterval(t);
  }, []);

  const tabs = [
    { id: "services", label: "Manage Services" },
    { id: "pricing", label: "Manage Pricing" },
    { id: "patients", label: "Patient Profiles" },
    { id: "appointments", label: "Appointments", badge: pendingCount },
    { id: "billing", label: "Billings", badge: unpaidCount },
    { id: "availability", label: "Doctor Available" },
    { id: "doctoraccount", label: "Doctor Accounts" },
    { id: "doctormanage", label: "Add Doctor" },
    { id: "hospitalsettings", label: "🏥 Hospital Settings" },
    { id: "subscription", label: "💳 Subscription" },
    { id: "dashboard", label: "📊 Dashboard" },
  ];

  return (
    <>
      {/* Inject responsive styles */}
      <style>{responsiveStyles}</style>

      {/* Top Bar */}
      <div className="admin-topbar">
        <div>
          <h3>Doctor Admin Panel</h3>
          <p>
            Welcome, {doctor?.name} — changes reflect live on the website
            instantly.
          </p>
        </div>
        <button className="admin-logout" onClick={logout}>
          Logout
        </button>
      </div>

      {/* ✅ Renewal banner — shows automatically when expiry is near or expired */}
      <RenewSubscription showNotify={showNotify} />

      {/* Tab Bar */}
      <div className="admin-tabs">
        {tabs.map((t) => (
          <button
            key={t.id}
            className={`admin-tab${activeTab === t.id ? " active" : ""}`}
            onClick={() => setActiveTab(t.id)}
          >
            {t.label}
            {t.badge > 0 && (
              <span className="admin-tab-badge">
                {t.badge > 99 ? "99+" : t.badge}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === "services" && <ServicesTab showNotify={showNotify} />}
      {activeTab === "pricing" && <PricingTab showNotify={showNotify} />}
      {activeTab === "patients" && (
        <PatientsTab showNotify={showNotify} doctor={doctor} />
      )}
      {activeTab === "appointments" && (
        <AppointmentsTab showNotify={showNotify} />
      )}
      {activeTab === "billing" && (
        <BillingTab showNotify={showNotify} doctor={doctor} />
      )}
      {activeTab === "availability" && (
        <DoctorAvailabilityTab showNotify={showNotify} />
      )}
      {activeTab === "doctoraccount" && (
        <DoctorAccountTab showNotify={showNotify} doctor={doctor} />
      )}
      {activeTab === "doctormanage" && (
        <DoctorManageTab showNotify={showNotify} />
      )}
      {activeTab === "hospitalsettings" && (
        <HospitalSettingsTab showNotify={showNotify} />
      )}
      {activeTab === "subscription" && (
        <SubscriptionPayment showNotify={showNotify} />
      )}
      {activeTab === "dashboard" && (
        <BillingDashboard showNotify={showNotify} />
      )}

      <AdminNotify
        show={notify.show}
        title={notify.title}
        msg={notify.msg}
        error={notify.error}
        onClose={() => setNotify((n) => ({ ...n, show: false }))}
      />
    </>
  );
}
